import React, { useEffect, useRef, useState } from "react";

import StepIndicator from './StepIndicator'
import "./BybBrewingProcess.css"
// import stepindicator from "../../../assets/selfaudit/images/stepindicator.svg"
function BybBrewingProcess() {

  
  const [isVisible, setIsVisible] = useState(false);

  const textRef = useRef(null);

  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);

  return (
   <>
   <section className='byb-bgps'>
<div className='container'>
<div className='byb-bgps-header'>
<h1 ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}>The Brand Brewing Process</h1>
<p >We've mapped out a clear journey to help you <span style={{ color: "white" }}> build and refine your brand, step by step.</span>
            </p>
</div>


<div className='res-stepone-main'>


<div className='byb-bgps-stepone'>
<h5>Step 1</h5>
<div className='byb-bgps-stepone-content'>
  <div className='byb-bgps-stepone-contentleft'>
  <h2>Assess Your Brand</h2>
  <p>Use the kit’s tools to evaluate your brand’s identity, market positioning, and customer perceptions. A thorough checklist ensures nothing is overlooked.</p>
  </div>
  <div className='byb-bgps-stepone-contentright'>
   <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/step1.svg" alt="Discover brewing process step visual" />
  </div>
</div>
</div>


<div className='byb-bgps-stepone'>
<h5>Step 2</h5>
<div className='byb-bgps-stepone-content'>
  <div className='byb-bgps-stepone-contentleft'>
  <h2>Analyse Findings</h2>
  <p>Leverage insights from your assessments to strategies. With templates and expert guidance, uncover areas for improvement in brand positioning and customer experience.</p>
  </div>
  <div className='byb-bgps-stepone-contentright'>
   <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/step2.svg" alt="Define brewing process step visual" />
  </div>
</div>
</div>



<div className='byb-bgps-stepone'>
<h5>Step 3</h5>
<div className='byb-bgps-stepone-content'>
  <div className='byb-bgps-stepone-contentleft'>
  <h2>Assess your brand</h2>
  <p>Use the kit’s tools to evaluate your brand’s identity, market positioning, and customer perceptions. The checklist ensures a thorough review of key areas, helping you uncover strengths, weaknesses, and opportunities for improvement. This step sets the foundation for strategic brand development.</p>
  </div>
  <div className='byb-bgps-stepone-contentright'>
   <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/step3.svg" alt="Develop brewing process step visual" />
  </div>
</div>
</div>

</div>




<StepIndicator/>
</div>
   </section>
   
   </>
  )
}

export default BybBrewingProcess
